import { render, staticRenderFns } from "./BottomSheet.vue?vue&type=template&id=4864bd44&"
import script from "./BottomSheet.js?vue&type=script&scoped=true&lang=js&"
export * from "./BottomSheet.js?vue&type=script&scoped=true&lang=js&"
import style0 from "./BottomSheet.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports